var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayPerNightGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 141.73 141.73",
    style: {
      enableBackground: "new 0 0 141.73 141.73"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Pay_per_night_-_Grey"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D7D7D7",
      stroke: "#D7D7D7",
      strokeMiterlimit: 10
    },
    d: "M118.946,79.365c-23.291-2.442-41.724-21.573-43.266-44.94 c-0.517-7.835,0.838-15.297,3.65-21.999c0.447-1.066-0.565-2.175-1.653-1.785c-19.81,7.091-33.665,26.696-32.009,49.298 c1.757,23.979,21.251,43.238,45.248,44.731c19.274,1.199,36.304-8.875,45.148-24.254c0.577-1.003-0.334-2.199-1.464-1.946 C129.628,79.579,124.373,79.933,118.946,79.365z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "80.307,109.382 52.676,109.641 52.676,88.084 67.101,88.084  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#D7D7D7",
      strokeWidth: 5,
      strokeMiterlimit: 10
    },
    x1: 76.506,
    y1: 103.595,
    x2: 67.101,
    y2: 89.277
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 8,
      strokeMiterlimit: 10
    },
    d: "M67.067,89.176h10.085 c0.85,0,1.406-0.891,1.032-1.655l-3.525-7.194c-0.386-0.788-1.187-1.287-2.064-1.287H14.258c-2.539,0-4.597,2.058-4.597,4.597 v33.582c0,2.539,2.058,4.597,4.597,4.597h5.945h12.57h23.876l12.434,0.101h7.005c2.539,0,4.597-2.058,4.597-4.597v-6.676 c0-0.448-0.131-0.887-0.377-1.262l-3.591-5.467L67.067,89.176z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#D7D7D7",
      strokeWidth: 5,
      strokeMiterlimit: 10
    },
    d: "M20.202,93.773v6.01 c0,2.539,2.058,4.597,4.597,4.597h17.972c2.539,0,4.597-2.058,4.597-4.597v-6.01c0-2.539-2.058-4.597-4.597-4.597H24.8 C22.261,89.176,20.202,91.234,20.202,93.773z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF",
      stroke: "#D7D7D7",
      strokeWidth: 5,
      strokeMiterlimit: 10
    },
    cx: 26.487,
    cy: 121.816,
    r: 6.285
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF",
      stroke: "#D7D7D7",
      strokeWidth: 5,
      strokeMiterlimit: 10
    },
    cx: 62.933,
    cy: 121.816,
    r: 6.285
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#D7D7D7",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    x1: 76.506,
    y1: 103.595,
    x2: 67.101,
    y2: 89.277
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D7D7D7",
      stroke: "#D7D7D7",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M76.439,103.916l-16.229,0.06 c-1.27,0-2.299-1.029-2.299-2.299V91.475c0-1.27,1.029-2.299,2.299-2.299h16.943c0.85,0,1.406-0.891,1.032-1.655l-3.525-7.194 c-0.386-0.788-1.187-1.287-2.064-1.287H14.258c-2.539,0-4.597,2.058-4.597,4.597v33.582c0,2.539,2.058,4.597,4.597,4.597h5.945 h12.57h23.876l12.434,0.101h7.005c2.539,0,4.597-2.058,4.597-4.597v-6.676c0-0.448-0.131-0.887-0.377-1.262l-3.591-5.467 L76.439,103.916z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#D7D7D7",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M20.202,93.773v6.01 c0,2.539,2.058,4.597,4.597,4.597h17.972c2.539,0,4.597-2.058,4.597-4.597v-6.01c0-2.539-2.058-4.597-4.597-4.597H24.8 C22.261,89.176,20.202,91.234,20.202,93.773z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF",
      stroke: "#D7D7D7",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    cx: 26.487,
    cy: 121.816,
    r: 6.285
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF",
      stroke: "#D7D7D7",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    cx: 62.933,
    cy: 121.816,
    r: 6.285
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayPerNightGrey);
export default __webpack_public_path__ + "static/media/Pay Per Night - Grey.84f25ef1fb56517474f248351830b3f5.svg";
export { ForwardRef as ReactComponent };